import styled from 'styled-components';

const Container = styled.div`
  height: 20px;
  width: 20px;
  text-align: center;
  svg {
    height: 20px;
    width: 20px;
    fill: ${(p) => p.theme.color.gray};
  }
  &:hover  {
    cursor: pointer;
  }
`;

export const Styled = {
  Container,
};
